module.exports = __webpack_public_path__ + "static/media/PLI.cfa17515.svg";